(function () {
  function initPowerBox(root) {
    if (!root || root.dataset.pbReady) return;
    root.dataset.pbReady = 'true';

    const images = Array.from(root.querySelectorAll('[data-pb-image]'));
    const thumbs = Array.from(root.querySelectorAll('[data-pb-thumb]'));
    let activeIndex = Math.max(0, images.findIndex(function (img) { return img.classList.contains('is-active'); }));

    function showImage(index) {
      if (!images.length) return;
      activeIndex = (index + images.length) % images.length;
      images.forEach(function (img, i) { img.classList.toggle('is-active', i === activeIndex); });
      thumbs.forEach(function (thumb, i) { thumb.classList.toggle('is-active', i === activeIndex); });
      if (thumbs[activeIndex]) thumbs[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { showImage(index); });
    });
    root.querySelector('[data-pb-prev]')?.addEventListener('click', function () { showImage(activeIndex - 1); });
    root.querySelector('[data-pb-next]')?.addEventListener('click', function () { showImage(activeIndex + 1); });

    const qtyInput = root.querySelector('[data-pb-quantity]');
    const stickyQty = root.querySelector('[data-pb-sticky-qty]');
    function setQty(value) {
      value = Math.max(1, parseInt(value || 1, 10));
      if (qtyInput) qtyInput.value = value;
      if (stickyQty) stickyQty.textContent = value;
    }
    root.querySelector('[data-pb-sticky-minus]')?.addEventListener('click', function () { setQty((qtyInput?.value || 1) - 1); });
    root.querySelector('[data-pb-sticky-plus]')?.addEventListener('click', function () { setQty((qtyInput?.value || 1) + 1); });

    const form = root.querySelector('[data-pb-product-form]');
    root.querySelector('[data-pb-sticky-add]')?.addEventListener('click', function () {
      if (form) form.requestSubmit();
    });

    const wishlist = root.querySelector('[data-pb-wishlist]');
    wishlist?.addEventListener('click', function () {
      const next = this.getAttribute('aria-pressed') !== 'true';
      this.setAttribute('aria-pressed', String(next));
      this.classList.toggle('is-active', next);
      this.textContent = next ? '♥' : '♡';
    });

    const sticky = root.querySelector('[data-pb-sticky]');
    const hero = root.querySelector('.pb-hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0.08 });
      observer.observe(hero);
    }
  }

  function boot() { document.querySelectorAll('.power-box').forEach(initPowerBox); }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.matches?.('.power-box') ? event.target : event.target.querySelector?.('.power-box');
    if (root) initPowerBox(root);
  });
})();
